import { ScheduleFilled } from "@ant-design/icons";
import { useCrm_task_statuses } from "../../../../hooks";
import { getFullName } from "../../../util/helpers";
import { useDispatch, useSelector } from "react-redux";
import { Typography } from "antd";
import { updateRecord } from "../../../../features/crm/activities/activitiesSlice";
import { Rate, Tag } from "antd";
import Actions from "./Actions";
import moment from "moment";
import { Link } from "react-router-dom";
import { useIntl } from "react-intl";
const { Text } = Typography;
const TasksListItem = (props) => {
  const { record, onEditTask, onReload } = props;
  const intl = useIntl();
  const profile = useSelector((state) => state.user.profile);

  const dispatch = useDispatch();
  const statuses = useCrm_task_statuses();
  const currentStatus =
    statuses && statuses.filter((i) => i.id === record.status_id)[0].name;
  const name = record.patient
    ? getFullName(record.patient.surename, record.patient.first_name)
    : record.employee
    ? getFullName(record.employee.surename, record.employee.first_name)
    : null;

  let entity = null;
  if (record && record.patient) {
    if (record.patient.status_id === 3) {
      entity = "crm/patients";
    } else {
      entity = "patients";
    }
  } else if (record && record.employee) {
    entity = "employees";
  }

  let entityId = null;
  if (record && record.patient) {
    entityId = record.patient.id;
  } else if (record && record.employee) {
    entityId = record.employee.id;
  }

  let branchId = null;
  if (record && record.patient) {
    branchId = record.patient.branch;
  } else if (record?.employee) {
    const employeeActiveBranchesIds = record.employee.active_branches.map(
      (branch) => branch.id
    );
    const userBranchesIds = profile?.branches.map((branch) => branch.id);

    // Find the first common branch ID
    branchId = employeeActiveBranchesIds.find((branchId) =>
      userBranchesIds.includes(branchId)
    );
  }

  const onRatingChanged = async (r) => {
    const activity = {
      id: record.id,
      has_star: r === 1,
    };

    const params = {
      activity,
      entity,
      entityId,
      activityType: "tasks",
      scope: `branches/${branchId}`,
    };
    const action = await dispatch(updateRecord(params));
    if (!action.error) {
    }
  };
  let entityPathName = "";
  if (record && record.patient) {
    if (record.patient.status_id === 3) {
      entityPathName = `crm_patients`;
    } else {
      entityPathName = `patients`;
    }
  } else if (record && record.employee) {
    entityPathName = `employees`;
  }
  const entityPath = `../../../../../branches/${branchId}/${entityPathName}/${entityId}`;

  return (
    <div className="task_item">
      <div className="task_inner">
        <div className="star">
          <Rate
            count={1}
            onChange={onRatingChanged}
            className="star_component"
            // style={{ color: "#ff9c2f33" }}
            value={record.has_star ? 1 : 0}
          />
        </div>
        <div className="item-horizontal-seperator" />
        <div className="task_content" style={{ width: "100%" }}>
          <div className="task_top">
            <div className="task_name">{record.subject}</div>
            <Actions
              record={record}
              onEditTask={onEditTask}
              onReload={onReload}
              branchId={branchId}
              entity={entity}
              entityId={entityId}
            />
          </div>
          <div className="task_relations">
            <ScheduleFilled style={{ color: "#5950ec", fontSize: "24px" }} />
            <div className="item-horizontal-seperator" />
            <div
              style={{ textDecoration: "underline", cursor: "pointer" }}
              onClick={() => {
                window.location.href = entityPath;
              }}
            >
              <div className="content">{name}</div>
            </div>
            <div className="item-horizontal-seperator" />
            <Text type="secondary">{`(${intl.formatMessage({
              id: `app.activities.${entityPathName}_label`,
            })})`}</Text>
          </div>
          <div className="task_bottom">
            <div className="task_status">
              <Text
                style={{
                  color: currentStatus === "canceled" ? "red" : "#969696",
                }}
              >{`${moment(record.due_date).format("L")} | ${intl.formatMessage({
                id: `app.dataSelect.status_id.${currentStatus}`,
              })}`}</Text>
            </div>
            <Text
              type={record?.prority?.name === "high" ? "danger" : "secondary"}
            >
              {intl.formatMessage({
                id: `app.dataSelect.priority_status.${record?.prority?.name}`,
              })}
            </Text>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TasksListItem;
